const FINAL_PURCHASE_UNITS_COLUMN_ID = 'final_purchase_units'
const TOTAL_POG_SET_QTY_COLUMN_ID = 'total_pog_fill_qty'
const MOQ_COLUMN_ID = 'moq'

function getNumericCellValue(value: unknown): number | undefined {
  if (typeof value !== 'number' && typeof value !== 'string') return undefined
  if (typeof value === 'string' && value.trim() === '') return undefined

  const numericValue = Number(value)
  return Number.isFinite(numericValue) ? numericValue : undefined
}

function formatQuantity(value: number): string {
  return value.toLocaleString('en-US', { maximumFractionDigits: 2 })
}

export function getQuantityShortfallTooltip(
  columnId: string,
  cells?: Record<string, unknown>,
  isOptionRow?: boolean
): string | undefined {
  if (!cells || isOptionRow) return undefined

  const finalPurchaseUnits = getNumericCellValue(
    cells[FINAL_PURCHASE_UNITS_COLUMN_ID]
  )
  const comparedQuantity = getNumericCellValue(cells[columnId])
  if (finalPurchaseUnits === undefined || comparedQuantity === undefined) {
    return undefined
  }

  if (
    columnId === TOTAL_POG_SET_QTY_COLUMN_ID &&
    finalPurchaseUnits < comparedQuantity
  ) {
    const shortfall = formatQuantity(comparedQuantity - finalPurchaseUnits)
    return `Final Purchase Units are ${shortfall} units short of the required POG Set Quantity (${formatQuantity(finalPurchaseUnits)} of ${formatQuantity(comparedQuantity)} units).`
  }

  if (columnId === MOQ_COLUMN_ID && finalPurchaseUnits < comparedQuantity) {
    const shortfall = formatQuantity(comparedQuantity - finalPurchaseUnits)
    return `Final Purchase Units are ${shortfall} units below the vendor MOQ (${formatQuantity(finalPurchaseUnits)} of ${formatQuantity(comparedQuantity)} units).`
  }

  return undefined
}
